<template>
  <div class="config-container">
    <div class="config-card">
      <h2>Configuración del Sitio</h2>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <div v-if="success" class="success-message">
        {{ success }}
      </div>
      
      <div v-if="loading" class="loading">
        Cargando configuraciones...
      </div>
      
      <div v-else class="config-options">
        <div class="config-option">
          <div class="option-label">Permitir nuevos registros</div>
          <div class="option-description">
            Cuando está desactivado, solo los administradores pueden crear nuevas cuentas
          </div>
          <div class="option-toggle">
            <button 
              class="toggle-btn" 
              :class="{ 'active': allowRegistration }"
              @click="toggleRegistration"
            >
              {{ allowRegistration ? 'Activado' : 'Desactivado' }}
            </button>
          </div>
        </div>
        
        <!-- Puedes añadir más opciones de configuración aquí -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import apiClient from '../../api'

export default {
  name: 'SiteConfig',
  setup() {
    const loading = ref(true)
    const error = ref(null)
    const success = ref(null)
    const allowRegistration = ref(true)
    
    const loadConfig = async () => {
      loading.value = true
      error.value = null
      
      try {
        const response = await apiClient.get('/admin/config')
        const configs = response.data
        
        // Buscar la configuración de registro
        const regConfig = configs.find(config => config.key === 'allow_registration')
        if (regConfig) {
          allowRegistration.value = regConfig.value.toLowerCase() === 'true'
        }
      } catch (err) {
        error.value = 'Error al cargar las configuraciones'
        console.error(err)
      } finally {
        loading.value = false
      }
    }
    
    const toggleRegistration = async () => {
      loading.value = true
      error.value = null
      success.value = null
      
      try {
        const newValue = !allowRegistration.value
        await apiClient.put(`/admin/config/allow_registration?value=${newValue}`)
        
        allowRegistration.value = newValue
        success.value = `Registros ${newValue ? 'activados' : 'desactivados'} correctamente`
      } catch (err) {
        error.value = 'Error al actualizar la configuración'
        console.error(err)
      } finally {
        loading.value = false
      }
    }
    
    onMounted(() => {
      loadConfig()
    })
    
    return {
      loading,
      error,
      success,
      allowRegistration,
      toggleRegistration
    }
  }
}
</script>

<style lang="scss" scoped>
.config-container {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
}

.config-card {
  width: 100%;
  max-width: 700px;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h2 {
    margin-bottom: 1.5rem;
    text-align: center;
    color: #333;
  }
}

.loading {
  text-align: center;
  padding: 2rem 0;
  color: #718096;
}

.config-options {
  margin-top: 1.5rem;
}

.config-option {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  
  .option-label {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    color: #2d3748;
  }
  
  .option-description {
    color: #718096;
    margin-bottom: 1rem;
  }
  
  .option-toggle {
    display: flex;
    justify-content: flex-end;
    
    .toggle-btn {
      background-color: #cbd5e0;
      color: #4a5568;
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 9999px;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.3s ease;
      
      &.active {
        background-color: #4299e1;
        color: white;
      }
    }
  }
}

.error-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  font-size: 0.875rem;
}

.success-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #c6f6d5;
  color: #2f855a;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>